/* custom-mamacool-picker.js
   The due-date picker shared by the "Not due yet?" sheet under Add to
   cart (custom-mamacool-registry.js) and the due-date section
   (custom-mamacool-due-date.js). README-registry.md.

   Markup contract inside `root` (all data attributes, no ids):
     [data-mc-registry-form]      the <form>
     [data-mc-registry-months]    month chip strip (role=radiogroup)
     [data-mc-registry-step="day"], [data-mc-registry-days]
     [data-mc-registry-readout]   the date in words (aria-live)
     [data-mc-registry-date]      visually hidden <input type="date">
     [data-mc-registry-step="email"], [name="email"], [type="submit"]
     [data-mc-registry-error]     role=alert, always rendered
     [data-mc-registry-intro], [data-mc-registry-done], [data-mc-registry-done-title]

   window.mcDuePicker.mount(root, {
     api, product, country, surface,      // posted to api/reminder
     hooks: {
       onLayout()          content changed height (the sheet refits)
       onFieldFocus()      the email field was just focused by a tap
       onOpen()            first month tap of this session
       onSaved(remindAt)   the reminder is stored (cookie already set)
       beforeSwap(swap)    called with the function that shows Done; call it
       afterSwap()         Done is showing
     }
   }) -> { reset(), rebuild() }
   Month chips are built by rebuild(); call it when the picker becomes
   visible so "today" is read then, not at page load. */
(function () {
  var MONTHS_AHEAD = 11, MAX_DAYS_AHEAD = 300;
  var SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function isoDate(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }
  function setCookie(name, value, days) {
    document.cookie = name + '=' + encodeURIComponent(value) + (days ? '; max-age=' + (days * 86400) : '') + '; path=/; SameSite=Lax; Secure';
  }
  function call(fn, a) { if (typeof fn === 'function') { try { return fn(a); } catch (e) { /* a hook must never break the picker */ } } }

  function mount(root, opts) {
    opts = opts || {};
    var hooks = opts.hooks || {};
    var q = function (s) { return root.querySelector(s); };
    var form = q('[data-mc-registry-form]');
    var monthsEl = q('[data-mc-registry-months]');
    var daysEl = q('[data-mc-registry-days]');
    var readout = q('[data-mc-registry-readout]');
    var dateInput = q('[data-mc-registry-date]');
    var errorEl = q('[data-mc-registry-error]');
    var intro = q('[data-mc-registry-intro]');
    var done = q('[data-mc-registry-done]');
    var doneTitle = q('[data-mc-registry-done-title]');
    var stepDay = q('[data-mc-registry-step="day"]');
    var stepEmail = q('[data-mc-registry-step="email"]');
    var emailInput = form.querySelector('[name="email"]');
    var submitBtn = form.querySelector('[type="submit"]');

    var tY, tM, tD, maxDate;
    var picked = { y: null, m: null, d: null };
    var opened = false;

    // Today is read on every rebuild: a tab left open past midnight must
    // not offer yesterday.
    function rebuild() {
      var today = new Date();
      tY = today.getFullYear(); tM = today.getMonth(); tD = today.getDate();
      maxDate = new Date(tY, tM, tD + MAX_DAYS_AHEAD);
      dateInput.min = isoDate(tY, tM, tD);
      dateInput.max = isoDate(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
      var html = '';
      for (var i = 0; i < MONTHS_AHEAD; i++) {
        var y = tY + Math.floor((tM + i) / 12), m = (tM + i) % 12;
        if (new Date(y, m, 1) > maxDate) break;
        html += '<button type="button" class="mc-registry__chip" role="radio" aria-checked="false" tabindex="' + (i ? '-1' : '0') + '" data-y="' + y + '" data-m="' + m + '">' + SHORT[m] + ' ' + y + '</button>';
      }
      monthsEl.innerHTML = html;
    }

    // One tab stop per group, arrows move between options (ARIA radiogroup).
    function select(group, btn) {
      var all = group.querySelectorAll('[role="radio"]');
      for (var j = 0; j < all.length; j++) {
        var on = all[j] === btn;
        all[j].classList.toggle('is-on', on);
        all[j].setAttribute('aria-checked', on ? 'true' : 'false');
        all[j].tabIndex = on ? 0 : -1;
      }
    }
    function moveFocus(group, from, step) {
      var all = Array.prototype.filter.call(group.querySelectorAll('[role="radio"]'), function (b) { return !b.disabled; });
      var i = all.indexOf(from);
      if (i === -1) return;
      var next = all[Math.max(0, Math.min(all.length - 1, i + step))];
      if (next && next !== from) { next.focus({ preventScroll: true }); next.click(); }
    }
    function renderDays() {
      var count = new Date(picked.y, picked.m + 1, 0).getDate(), out = '', firstOn = null;
      for (var d = 1; d <= count; d++) {
        var dt = new Date(picked.y, picked.m, d);
        var off = dt < new Date(tY, tM, tD) || dt > maxDate;
        if (!off && firstOn === null) firstOn = d;
        out += '<button type="button" class="mc-registry__day" role="radio" aria-checked="false" tabindex="-1" data-d="' + d + '"' + (off ? ' disabled' : '') +
          ' aria-label="' + LONG[picked.m] + ' ' + d + ', ' + picked.y + '">' + d + '</button>';
      }
      daysEl.innerHTML = out;
      dateInput.value = '';
      var first = firstOn !== null ? daysEl.querySelector('[data-d="' + firstOn + '"]') : null;
      if (first) first.tabIndex = 0;
    }
    // The date in words, so she can check it without a calendar view.
    function showReadout() {
      if (picked.m === null) { readout.textContent = ''; readout.classList.remove('is-set'); return; }
      if (picked.d === null) { readout.textContent = LONG[picked.m] + ' ' + picked.y + ', pick a day'; readout.classList.remove('is-set'); return; }
      var dt = new Date(picked.y, picked.m, picked.d);
      readout.textContent = 'Due ' + WEEKDAYS[dt.getDay()] + ', ' + LONG[picked.m] + ' ' + picked.d + ', ' + picked.y;
      readout.classList.add('is-set');
    }
    function showError(msg) { errorEl.textContent = msg; }
    function hideError() { errorEl.textContent = ''; }

    function pickMonth(b) {
      if (!opened) { opened = true; call(hooks.onOpen); }
      picked.y = Number(b.dataset.y); picked.m = Number(b.dataset.m); picked.d = null;
      select(monthsEl, b);
      renderDays();
      hideError();
      stepDay.hidden = false;
      showReadout();
      try { b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (err) { /* ignore */ }
      call(hooks.onLayout);
    }
    function pickDay(b, pointer) {
      picked.d = Number(b.dataset.d);
      select(daysEl, b);
      dateInput.value = isoDate(picked.y, picked.m, picked.d);
      hideError();
      showReadout();
      var first = stepEmail.hidden;
      stepEmail.hidden = false;
      call(hooks.onLayout);
      if (first && pointer) {
        // Synchronous, inside the tap: that is what lets WebKit raise the
        // keyboard and the saved-address bar for a programmatic focus.
        // preventScroll keeps the document still; the host scrolls itself.
        try { emailInput.focus({ preventScroll: true }); } catch (err) { try { emailInput.focus(); } catch (e2) { /* ignore */ } }
        call(hooks.onFieldFocus);
      }
    }

    monthsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.mc-registry__chip');
      if (b) pickMonth(b);
    });
    daysEl.addEventListener('click', function (e) {
      var b = e.target.closest('.mc-registry__day');
      // e.detail is 0 for keyboard activation and for the .click() the arrow
      // keys use; a real tap or mouse click carries a count.
      if (b && !b.disabled) pickDay(b, e.detail > 0);
    });
    monthsEl.addEventListener('keydown', function (e) {
      var b = e.target.closest('.mc-registry__chip');
      if (!b) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); moveFocus(monthsEl, b, 1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); moveFocus(monthsEl, b, -1); }
    });
    daysEl.addEventListener('keydown', function (e) {
      var b = e.target.closest('.mc-registry__day');
      if (!b) return;
      var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : e.key === 'ArrowDown' ? 7 : e.key === 'ArrowUp' ? -7 : 0;
      if (step) { e.preventDefault(); moveFocus(daysEl, b, step); }
    });
    // Keyboard / screen-reader path: the native date input drives the same state.
    dateInput.addEventListener('change', function () {
      hideError();
      var v = dateInput.value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!v) return;
      if (dateInput.value < dateInput.min || dateInput.value > dateInput.max) { dateInput.value = ''; showError('Pick a date in the next ten months.'); return; }
      if (!opened) { opened = true; call(hooks.onOpen); }
      picked.y = Number(v[1]); picked.m = Number(v[2]) - 1; picked.d = Number(v[3]);
      var chip = monthsEl.querySelector('[data-y="' + picked.y + '"][data-m="' + picked.m + '"]');
      if (chip) select(monthsEl, chip);
      stepDay.hidden = false; stepEmail.hidden = false;
      renderDays();
      var day = daysEl.querySelector('[data-d="' + picked.d + '"]');
      if (day) select(daysEl, day);
      dateInput.value = isoDate(picked.y, picked.m, picked.d);
      showReadout();
      call(hooks.onLayout);
    });

    function reset() {
      picked = { y: null, m: null, d: null };
      opened = false;
      form.hidden = false; if (intro) intro.hidden = false; if (done) done.hidden = true;
      stepDay.hidden = true; stepEmail.hidden = true;
      daysEl.innerHTML = ''; dateInput.value = '';
      monthsEl.scrollLeft = 0;
      submitBtn.disabled = false;
      hideError(); showReadout();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideError();
      var email = emailInput.value.trim();
      var due = dateInput.value;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(due)) { showError('Pick your due date.'); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showError('Enter a real email address.'); try { emailInput.focus({ preventScroll: true }); } catch (err) { /* ignore */ } return; }
      submitBtn.disabled = true;
      var params = new URLSearchParams(location.search);
      // Where the shopper really is. country_code is the Shopify market
      // (visitors from countries we have no market for land on the default
      // one), so send the browser's own locale and timezone as well.
      var locale = '', tz = '';
      try { locale = navigator.language || ''; } catch (err) { /* ignore */ }
      try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (err) { /* ignore */ }
      fetch(opts.api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          due_date: due,
          product_handle: opts.product || '',
          country_code: opts.country || '',
          browser_locale: locale,
          timezone: tz,
          surface: opts.surface || '',
          source: params.get('utm_source') || document.referrer.replace(/^https?:\/\//, '').split('/')[0] || ''
        })
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { var err = new Error(res.body && res.body.error || 'Could not save that. Try again in a minute.'); err.shown = !!(res.body && res.body.error); throw err; }
          setCookie('mc_registry', 'reminder', 90);
          var v = String(res.body.remind_at || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
          if (doneTitle) doneTitle.textContent = v ? 'Done. We’ll email you on ' + LONG[Number(v[2]) - 1] + ' ' + Number(v[3]) + '.' : 'Done. We’ll email you four weeks before you’re due.';
          call(hooks.onSaved, res.body.remind_at || '');
          var swapped = false;
          function swap() {
            if (swapped) return; swapped = true;
            form.hidden = true; if (intro) intro.hidden = true; if (done) done.hidden = false;
            call(hooks.afterSwap);
          }
          if (typeof hooks.beforeSwap === 'function') { try { hooks.beforeSwap(swap); } catch (err) { swap(); } }
          else swap();
        })
        .catch(function (err) {
          showError(err && err.shown ? err.message : 'Could not save that. Try again in a minute.');
          submitBtn.disabled = false;
        });
    });

    return { reset: reset, rebuild: rebuild };
  }

  window.mcDuePicker = { mount: mount };
})();
